module.exports = __webpack_public_path__ + "static/media/sitemap.1b037af0.xml";